<template>
  <div class="my">
    <div class="top">
      <div class="information">
        <div class="left">
          <!-- <img
            @click="surprise()"
            class="avatar"
            src="@/assets/image/my/avatar.png"  
          /> -->
          <div class="detail">
            <p class="name" @click="surprise()">
              {{ user.name }}
            </p>
            <p class="organization">
              {{ user.tenant_name }}
              -
              {{ user.department_name }}
            </p>
            <p class="organization">
              <span v-if="userCenter.auth_type == 1">到期时间：{{ userCenter.tenant_end_time }}</span>
              <span v-else>可用标签：{{ userCenter.effective_tag_number }}</span>
            </p>
          </div> 
        </div>
        <div class="right">
          <img
            @click="checkCamera"
            class="contract-icon"
            src="@/assets/image/my/scan.png"  
          />
          
          <img
            id="callServiceEle"
            @click="callService"
            class="contract-icon"
            src="@/assets/image/my/contract.png"  
          />
        </div>
      </div>

      <div class="short-cuts">
        <div class="item" @click="goPage('/password')">
          <div class="left">
            <img src="@/assets/image/my/lock.png" class="icon">
            <p class="title">
              修改密码
            </p>
          </div>
          <img src="@/assets/image/my/right.png" alt="" class="right-icon">
        </div>
        <div class="item" @click="clear">
          <div class="left">
            <img src="@/assets/image/my/clear.png" class="icon">
            <p class="title">
              清除缓存
            </p>
          </div>
          <img src="@/assets/image/my/right.png" alt="" class="right-icon">
        </div>
        <div class="item" @click="$utils.app.openUrl(`${productionHost}/agreement`)">
          <div class="left">
            <img src="@/assets/image/my/book.png" class="icon">
            <p class="title">
              服务协议
            </p>
          </div>
          <img src="@/assets/image/my/right.png" alt="" class="right-icon">
        </div>
        <div class="item" @click="$utils.app.openUrl(`${productionHost}/privacy`)">
          <div class="left">
            <img src="@/assets/image/my/sheild.png" class="icon">
            <p class="title">
              隐私政策
            </p>
          </div>
          <img src="@/assets/image/my/right.png" alt="" class="right-icon">
        </div>
        <div class="item" @click="goPage('/printerRecord')">
          <div class="left">
            <img src="@/assets/image/my/print.png" class="icon">
            <p class="title">
              激活打印机记录
            </p>
          </div>
          <img src="@/assets/image/my/right.png" alt="" class="right-icon">
        </div>
        <div class="item" @click="goPage('/tagRecord')">
          <div class="left">
            <img src="@/assets/image/my/tag.png" class="icon">
            <p class="title">
              核销标签码记录
            </p>
          </div>
          <img src="@/assets/image/my/right.png" alt="" class="right-icon">
        </div>
        <div class="item" id="commonProblemEle" @click="goPage('/problem')">
          <div class="left">
            <img src="@/assets/image/my/problem.png" class="icon">
            <p class="title">
              常见问题
            </p>
          </div>
          <img src="@/assets/image/my/right.png" alt="" class="right-icon">
        </div>
        <div class="item" @click="goPage('/updateNotice')">
          <div class="left">
            <img src="@/assets/image/my/update.png" class="icon">
            <p class="title">
              更新公告
            </p>
            <div class="spot" v-if="unread" />
          </div>
          <img src="@/assets/image/my/right.png" alt="" class="right-icon">
        </div>
      </div>
    </div>
    <div class="bottom">
      <van-button
        type="warning"
        plain
        class="big-btn"
        @click="handleLogOut"
        color="#44D0C9"
      > 退出登录 </van-button>
      <van-button
        type="danger"
        plain
        class="big-btn"
        color="#44D0C9"
        @click="handleCancelAccount"
      > 用户注销 </van-button>
      <p v-if="appInfo && appInfo.appWgtVersion" class="version">
        当前版本：{{ appInfo && appInfo.appWgtVersion }}
      </p>
    </div>

    <verify-printer-number
      ref="VerifyPrinterNumber"
      @confirm="getVerifyData"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VerifyPrinterNumber from './components/VerifyPrinterNumber.vue'
import {
  verifyMaterial
} from '@/api/material';
import {
  checkPrinterCode,
  activePrinter
} from '@/api/printer';
import {
  cancelAccount
} from '@/api/login';
import {
  isUnRead
} from '@/api/update';
import {
  getUserCenter
} from '@/api/system';
import {
  userTokenKey,
  productionHost
} from '@/config/index';
import {
  Dialog
} from 'vant';
export default {
  name: 'My',
  computed: {
    ...mapGetters([ 'user', 'appInfo','userCenter' ])
  },
  components: {
    VerifyPrinterNumber
  },
  data() {
    return {
      count: 0,
      productionHost,
      unread:false
    }
  },
  created() {
    isUnRead().then((res) => {
      if (res) {
        this.unread = res.unread
      }
    })
  },
  methods: {
    ...mapActions(['setUserCenter']),
    goPage(path) {
      if(path == '/problem'){
        window._hmt && _hmt.push(['_trackEvent', '常见问题', 'click', JSON.stringify(this.user)]);
      }
      this.$router.push(path)
    },
    wait() {
      this.$Toast('准备中，敬请期待')
    },
    callService() {
      const config = {
        event: 'callService'
      }

      this.$utils.app.sendAppMsg(config)
      // this.wait()
      window._hmt && _hmt.push(['_trackEvent', '客服按钮', 'click', this.user]);
    },
    clear() {
      const config = {
        event: 'clearCache'
      }

      this.$utils.app.sendAppMsg(config)
      this.$Toast('操作完成')
    },
    // 检查相机权限
    checkCamera() {
      const versionStatus = this.$utils.app.limitVersion('1.0.5')
      if (!versionStatus) return

      const config = {
        event: 'checkCamera',
        params: {},
        callback: this.checkCameraStatus
      }
      this.$utils.app.sendAppMsg(config)
    },

    checkCameraStatus(data){
      const {
        storages: info
      } = data

      if (!info) {
        Dialog.confirm({
          title: '权限确认',
          message: '为了保证相机功能正常使用，需要您授权访问相机信息，是否继续？(如授权后仍然遇到此提示，请重装app后进行授权)',
          confirmButtonText: '去授权'
        }).then((res) => {
          this.requestCamera()
        }).catch((err) => {
          
        });
      }else {
        this.openScan()
      }
    },
    requestCamera() {
      const config = {
        event: 'requestCamera',
        params: {},
        callback: this.requestAuthStatus
      }
      this.$utils.app.sendAppMsg(config)
    },
    requestAuthStatus(data){
      if (data != 0) {
        this.openScan()
      }
    },  
    openScan() {
      const config = {
        event: 'scanCode',
        callback: this.getScanCode
      }

      this.$utils.app.sendAppMsg(config)
    },
    getScanCode(data) {
      // 获取扫码结果
      const {
        status,
        code,
        scanType
      } = data

      if (status === 'success') {
        this.$Toast(`扫到的码是：${code}`)
        this.handleScanCode(code, scanType)
      } else if (status === 'fail') {
        this.$Toast.fail('取消扫码')
      }
    },
    async handleScanCode(code, scanType) {
      // 处理扫描到的码
      const permitScanTypes = [ // 允许扫描的码类型
        'QR_CODE',
        'DATA_MATRIX',
        'PDF_417',
        'CODE_128'
      ]
      const type = scanType ? scanType.toUpperCase() : ''
      if (!permitScanTypes.includes(type)) {
        this.$Toast.fail('扫码出错，请重新扫描')
        return
      }
      
      this.$utils.matchCodeConfig(code)
      .then(rule => {
        if (rule) {
        // 匹配到规则，按照规则处理
        const {
          id
        } = rule
        if (id === 44) {
          this.verfifyTags(code)
        }
      } else {
        // 无匹配规则
        // 默认为打印机编码，激活打印机
        this.checkPrinterCodeStatus(code)
      }
      })
    },
    verfifyTags(code) {
      // 核销标签耗材
      const query = {
        code
      }
      verifyMaterial(query)
      .then(res => {
        if (res) {
          const {
            msg
          } = res
          
          this.$Toast.success({
            duration: 3000,
            message: msg
          })

          this.refreshUserInfo()
        }
      })
    },
    refreshUserInfo(){
      // 核销成功刷新用户信息
      getUserCenter(true).then((res) => {
        this.setUserCenter(res)
      })
    },
    checkPrinterCodeStatus(code) {
      // 检查设备编号状态
      const query = {
        number: code
      }

      checkPrinterCode(query)
      .then(res => {
        if (res) {
          const {
            serial_number
          } = res
          const {
            VerifyPrinterNumber
          } = this.$refs

          VerifyPrinterNumber && VerifyPrinterNumber.open({code, snPrefix: serial_number})
        }
      })
    },
    getVerifyData(data) {
      // 获取激活验证数据
      const {
        code,
        number
      } = data
      const params = {
        number: code,
        serial_number: number
      }

      activePrinter(params)
      .then(res => {
        if (res) {
          this.$Toast.success('激活成功')
        }
      })
    },
    surprise() {
      if (this.count >= 9) {
        this.goAppUrlPage()
        this.count = 0
        return
      }

      this.count += 1
    },
    goAppUrlPage() {
      const config = {
        event: 'goUrlPage'
      }

      this.$utils.app.sendAppMsg(config)
    },
    handleLogOut() {
      // 退出登录
      Dialog.confirm({
        message: '是否确认退出登录状态'
      })
      .then(() => {
        this.logOut()
        // this.quitApp()
      })
    },
    logOut() {
      this.$cookie.remove(userTokenKey)
      this.$router.replace('/login')
    },
    handleCancelAccount() {
      Dialog.confirm({
        message: '用户注销后将不能继续使用产品，是否注销？'
      })
      .then(() => {
        this.cancelAccount()
      })
    },
    cancelAccount() {
      // 注销账户
      cancelAccount()
      .then(res => {
        if (res) {
          Dialog.alert({
            message: '您的账号已成功注销',
            confirmButtonText: '关闭'
          })
          .then(() => {
            // 关闭app
            this.logOut()
            this.quitApp()
          })
        }
      })
    },
    quitApp() {
      const config = {
        event: 'quit'
      }

      this.$utils.app.sendAppMsg(config)
    }
  }
}
</script>

<style lang="less" scoped>
  .my {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .information {
      // background-color: #fff;
      padding: 72px 64px 58px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        display: flex;
        align-items: center;
        flex: 1;
        position: relative;
        .avatar {
          width: 200px;
          height: 200px;
          margin-right: 54px;
        }
        .detail {
          display: flex;
          flex: 1;
          // height: 200px;
          flex-direction: column;
          justify-content: space-around;
          overflow: hidden;
          .name {
            color: @font-black-1;
            font-size: 48px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .organization {
            color: @font-gray-2;
            font-size: 40px;
            overflow: hidden;
            text-overflow: ellipsis;
            // white-space: nowrap;
            margin-top: 5px;
            &-nums{
              position: absolute;
              left: 690px;
            }
          }
        }
      }
      .right{
        width: 336px;
        margin-top: -50px;
      }
      .contract-icon {
        width: auto;
        height: 128px;
        margin: 0 0 0 20px;
        &:not(:first-child) {
          margin: 0 0 0 60px;
        }
      }
    }

    .short-cuts {
      margin: 68px 0 0;
      padding: 0 66px;
      display: flex;
      flex-direction: column;
      // gap: 30px;
      .flexgap(30px, column);

      .item {
        background-color: rgba(254, 254, 254, 0.3);
        height: 166px;
        padding: 0 30px 0 18px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 6px;
        box-shadow: 0px 0px 4px 2px rgba(68, 208, 201, 0.1);
        .left {
          display: flex;
          align-items: center;
          .icon {
            width: 72px;
            height: 72px;
          }
          .title {
            margin: 0 0 0 24px;
            color: @font-black-2;
            font-size: 36px;
          }
          .spot{
            width: 18px;
            height: 18px;
            background: #FF0000;
            border-radius: 50%;
            margin-top: -30px;
            margin-left: 3px;
          }
        }
        .right-icon {
          width: auto;
          height: 44px;
        }
      }
    }

    .bottom {
      padding: 0 66px;
      margin-top: 200px;
    }
    .version {
      color: @font-gray-1;
      font-size: 32px;
      text-align: center;
      width: 100%;
    }
    .big-btn {
      width: 100%;
      margin: 4px 0;
      border: none;
      box-shadow: 0px 0px 1px 2px rgba(68,208,201,0.1);
    }
  }
</style>